// extracted by mini-css-extract-plugin
export default {"ContactInfoClass":"ContactInfo_ContactInfoClass__XXpIj","footerLinksOpen":"ContactInfo_footerLinksOpen__4Qprv"};